import PageContainer from '@/common/components/PageContainer'
import EditAnnouncementListing from '@/modules/announcement/components/EditAnnouncement/components/EditAnnouncementListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function UpdateAnnouncementPage() {
	return (
		<PageContainer>
			<EditAnnouncementListing />
		</PageContainer>
	)
}

const GuardedUpdateAnnouncementPage = withUserPermission(
	UpdateAnnouncementPage,
	{
		permissionType: PermissionType.Write,
		permissionKey: [PermissionKeys.MANAGE_ANNOUNCEMENT],
	},
)

export default GuardedUpdateAnnouncementPage
